/* Wild Captives — tactile button press + light haptics. No content hiding. */
(function(){'use strict';
  try{
    var pressed=function(t){return t&&t.closest?t.closest('.button'):null;};
    document.addEventListener('pointerdown',function(ev){var b=pressed(ev.target);if(b)b.classList.add('wc-press');},{passive:true});
    var release=function(){var l=document.querySelectorAll('.button.wc-press');for(var i=0;i<l.length;i++)l[i].classList.remove('wc-press');};
    document.addEventListener('pointerup',release,{passive:true});
    document.addEventListener('pointercancel',release,{passive:true});
    document.addEventListener('click',function(ev){if(pressed(ev.target)&&navigator.vibrate){try{navigator.vibrate(8);}catch(e){}}},{passive:true});
  }catch(e){}
})();

/* Wild Captives — sticky Add-to-Cart bar (product pages).
   Shows a compact fixed bar once the main Add-to-Cart has scrolled above it;
   the button proxies a click to the real Add-to-Cart so variant/quantity
   selections are respected. Uses direct scroll/resize listeners plus an
   IntersectionObserver so toggling stays reliable (no rAF, which browsers
   pause in background tabs). */
(function(){'use strict';
  function start(){
    var bar=document.getElementById('wc-sticky-atc');
    if(!bar) return;
    var attempts=0;
    (function ready(){
      var mainAtc=document.querySelector('.product-content-container .add-to-cart');
      if(!mainAtc){ if(attempts++<20){ setTimeout(ready,150); } return; }
      wire(bar, mainAtc);
    })();
  }
  function wire(bar, mainAtc){
    var stickyBtn=document.getElementById('wc-sticky-atc-btn');
    var priceEl=document.getElementById('wc-sticky-price');

    /* The bar sits just under the sticky header when the header is in view. */
    var stickyHeader=document.querySelector('.shopify-section-group-header-group');
    if(!stickyHeader){ var hdr=document.querySelector('header'); stickyHeader=hdr&&hdr.closest?hdr.closest('.shopify-section-group-header-group'):null; }
    function headerBottom(){
      if(!stickyHeader) return 0;
      var r=stickyHeader.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    }

    var visible=false;
    function show(){ if(visible) return; visible=true; bar.classList.add('wc-visible'); bar.setAttribute('aria-hidden','false'); }
    function hide(){ if(!visible) return; visible=false; bar.classList.remove('wc-visible'); bar.setAttribute('aria-hidden','true'); }

    /* Mirror the live price. The main ATC shows "Add to cart • $x" and
       updates on variant change, so read it as the price source. */
    function syncPrice(){
      if(!priceEl) return;
      var m=(mainAtc.textContent||'').match(/[£€$][0-9][0-9.,]*/);
      if(m){ priceEl.textContent=m[0]; }
    }
    syncPrice();
    try{ new MutationObserver(syncPrice).observe(mainAtc,{childList:true,subtree:true,characterData:true}); }catch(e){}

    /* Show only once the main ATC has scrolled above the bar; hide while the
       main ATC is still in view or below the fold. */
    function update(){
      var top=headerBottom();
      bar.style.setProperty('--wc-sticky-atc-top', top+'px');
      var rect=mainAtc.getBoundingClientRect();
      if(rect.bottom <= top + 2){ show(); } else { hide(); }
    }
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    try{ new IntersectionObserver(function(){ update(); }, {threshold:[0,1]}).observe(mainAtc); }catch(e){}
    update();

    /* Proxy the click to the real Add-to-Cart button. */
    if(stickyBtn){
      stickyBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        try{ mainAtc.click(); }catch(e){}
      });
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
